<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Código Eppo</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">
                        <div class="row">

                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="inpCodigoEppo">Código Eppo</label>
                                <input formControlName="CodigoEppo" name="CodigoEppo" maxlength="50" [ngClass]="displayFieldCss('CodigoEppo')"
                                       class="form-control" inputStyleClass="form-control" id="inpCodigoEppo" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoEppo','required')">
                                    Código Eppo es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoEppo','descripcion_duplicated')">
                                    El Código Eppo ya existe
                                </div>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpDescripcion">Invasora no permitida</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="InvasivaNoPermitida" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
